import React, { Fragment } from 'react';
import Select from 'react-select';


const CategoryMenu = ({
  action,
  base
}) => {

  const slug = window.location.pathname.replace('/blog/category/', '');

  const categories = [
    { label: "Home", slug: "", value: "blog"},
    { label: "Early Learning", slug: "early-learning", value: "early-learning"},
    { label: "Parenting", slug: "parenting", value: "parenting"},
    { label: "Nature", slug: "nature", value: "nature"},
    { label: "Independent Play", slug: "independent-play", value: "independent-play"},
    { label: "All Posts", slug: "all", value: "all"}
  ];

  const parseValue = () => {
    if (action === 'index') {
      return null
    }

    if (action === 'category') {
      const { label, value } = categories.find((i) => i.slug === slug);
      return {
        label: label,
        value: value
      }
    }

    if (action === 'show') {
      if (base) {
        const { label, value } = categories.find((i) => i.slug === base);
        return {
          label: label,
          value: value
        }
      }
    }

    return null;
  }

  const toggleActive = (value) => {
    if (value === 'blog' && action === 'index') return 'active';
    if (action === 'category' && value === slug) return 'active';
    if (action === 'show' && value === base) return 'active';
  }

  const handleChange = (value) => window.location = `/blog/category/${ value }`;

  return (
    <Fragment>
      <ul className='m-0 none border-b-1 tg-tab-nav list-none hidden lg:flex'>
        {categories.map(({ label, value }) => (
          <li key={value} className={toggleActive(value)}>
            <a href={`${ (value !== 'blog') ? `/blog/category/` : '/' }${ value }`} className="text-black">
            {label}
            </a>
          </li>
        ))}
      </ul>
      <div className='flex flex-col lg:hidden'>
        <Select
          options={categories}
          onChange={({ value }) => handleChange(value)}
          placeholder='Select Blog Category'
          value={parseValue()}
        />
      </div>
    </Fragment>
  )
}

export default CategoryMenu;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/CategoryMenu/index.jsx